// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"b5808026","471":"f888930b","513":"84a747b4","528":"230862e8","542":"928fde58","635":"4401f12b","705":"fa17e990","815":"d57f23c6","861":"d8be4621","876":"58cc37f7","970":"965e8f10","991":"7c747b82"}[chunkId] + ".chunk.css";
};